import { render, staticRenderFns } from "./rejected-dialog.vue?vue&type=template&id=add21786&"
import script from "./rejected-dialog.vue?vue&type=script&lang=js&"
export * from "./rejected-dialog.vue?vue&type=script&lang=js&"
import style0 from "./rejected-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports